import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { MobileTopBar } from './MobileTopBar';
import { BottomNav } from './BottomNav';

export const Layout = () => {
  return (
    <div className="flex flex-1 flex-col md:flex-row">
      <MobileTopBar />
      <Sidebar />
      <main className="flex-1 p-4 md:p-6 pb-20 md:pb-6 overflow-auto">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};
